document.addEventListener("DOMContentLoaded",()=>{

const slider = document.querySelector(".tec-social__slider");
const nextBtn = document.querySelector(".tec-social__arrow--right");
const prevBtn = document.querySelector(".tec-social__arrow--left");

if(!slider) return;

let autoScroll;
let isDown = false;
let startX;
let scrollLeft;

/* =========================
AUTO SCROLL SUAVE CONTINUO
========================= */

function startAutoScroll(){

clearInterval(autoScroll);

autoScroll = setInterval(()=>{

const maxScroll = slider.scrollWidth - slider.clientWidth;

/* VELOCIDAD LENTA Y ESTABLE */
slider.scrollLeft += 0.3;

/* CUANDO LLEGA AL FINAL → REINICIA */
if(slider.scrollLeft >= maxScroll){
slider.scrollLeft = 0;
}

},20);

}

function stopAutoScroll(){
clearInterval(autoScroll);
}

/* =========================
DRAG / MOUSE
========================= */

slider.addEventListener("mousedown",(e)=>{
isDown = true;
startX = e.pageX - slider.offsetLeft;
scrollLeft = slider.scrollLeft;
stopAutoScroll();
});

slider.addEventListener("mouseleave",()=>{
isDown = false;
startAutoScroll();
});

slider.addEventListener("mouseup",()=>{
isDown = false;
startAutoScroll();
});

slider.addEventListener("mousemove",(e)=>{
if(!isDown) return;
e.preventDefault();

const x = e.pageX - slider.offsetLeft;
const walk = (x - startX) * 1.5;

slider.scrollLeft = scrollLeft - walk;
});

/* =========================
TOUCH (MOBILE)
========================= */

slider.addEventListener("touchstart",()=>{
stopAutoScroll();
});

slider.addEventListener("touchend",()=>{
startAutoScroll();
});

/* =========================
HOVER
========================= */

slider.addEventListener("mouseenter",stopAutoScroll);
slider.addEventListener("mouseleave",startAutoScroll);

/* =========================
FLECHAS MANUALES
========================= */

if(nextBtn){
nextBtn.addEventListener("click",()=>{
stopAutoScroll();

slider.scrollBy({
left:320,
behavior:"smooth"
});

setTimeout(()=>{
startAutoScroll();
},1200);
});
}

if(prevBtn){
prevBtn.addEventListener("click",()=>{
stopAutoScroll();

slider.scrollBy({
left:-320,
behavior:"smooth"
});

setTimeout(()=>{
startAutoScroll();
},1200);
});
}

/* INIT */

startAutoScroll();

});